import React from 'react';
import './loading.scss';
import LogoSvg from '../assets/brand/logo_black.svg';

const Loading = ({ insideComponent, customWidth, message, messages = [], rotateIntervalMs = 2500 }) => {
    const [currentMessageIndex, setCurrentMessageIndex] = React.useState(0);
    const hasRotation = Array.isArray(messages) && messages.length > 0;

    React.useEffect(() => {
        if (!hasRotation) return;
        const interval = setInterval(() => {
            setCurrentMessageIndex((idx) => (idx + 1) % messages.length);
        }, rotateIntervalMs);
        return () => clearInterval(interval);
    }, [hasRotation, messages, rotateIntervalMs]);

    const computedMessage = hasRotation ? messages[currentMessageIndex] : message;
    const showDots = Boolean(computedMessage) && !/\.\.\.$/.test(String(computedMessage).trim());
    const SingleLoader = () => (
        <svg width="114" height="111" viewBox="0 0 228 111" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g filter="url(#filter0_i_3501_46438)">
                <image href={LogoSvg} alt="Logo" width="100%" height="100%" />
            </g>
            <defs>
                <filter
                    id="filter0_i_3501_46438"
                    x="0"
                    y="0"
                    width="227.229"
                    height="117.894"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy="7.05073" />
                    <feGaussianBlur stdDeviation="8.81342" />
                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0.134809 0 0 0 0 0.134809 0 0 0 0 0.134809 0 0 0 0.35 0"
                    />
                    <feBlend mode="normal" in2="shape" result="effect1_innerShadow_3501_46438" />
                </filter>
                <linearGradient
                    id="paint0_linear_3501_46438"
                    x1="0"
                    y1="55.4217"
                    x2="227.229"
                    y2="55.4217"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#C9FFBF" />
                    <stop offset="1" stopColor="#FFAFAF" />
                </linearGradient>
            </defs>
        </svg>
    );

    return insideComponent ? (
        <div className="f fd-c ai-c jc-c">
            <div className="loader" style={{ width: customWidth || 150 }}>
                {SingleLoader()}
                {SingleLoader()}
                {SingleLoader()}
            </div>
            {computedMessage && (
                <div className="loader-message" role="status" aria-live="polite" aria-busy="true">
                    <span>{computedMessage}</span>
                    {showDots && <span className="dots">...</span>}
                </div>
            )}
        </div>
    ) : (
        <div className="f ai-c jc-c fb-100" style={{ height: '100vh' }}>
            <div className="f fd-c ai-c jc-c">
                <div className="loader" style={{ width: 150 }}>
                    {SingleLoader()}
                    {SingleLoader()}
                    {SingleLoader()}
                </div>
                {computedMessage && (
                    <div className="loader-message" role="status" aria-live="polite" aria-busy="true">
                        <span>{computedMessage}</span>
                        {showDots && <span className="dots">...</span>}
                    </div>
                )}
            </div>
        </div>
    );
};

export default Loading;
